"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Project = require("./Project");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * HeaderCell - Composant header/navigation responsive
 */const HeaderCell = ({
  items = [],
  styles_properties = {},
  className = '',
  style = {},
  logoUri,
  logoAlt = 'Logo',
  onItemClick,
  onActionLog,
  onLogoClick,
  ...rest
}) => {
  const projectContext = (0, _react.useContext)(_Project.ProjectContext);

  // Styles du conteneur header
  const containerStyle = {
    backgroundColor: styles_properties.background_color || '#ffffff',
    color: styles_properties.text_color,
    fontSize: styles_properties.text_size ? `${styles_properties.text_size}px` : undefined,
    fontFamily: styles_properties.text_font,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    textAlign: styles_properties.text_align,
    ...style
  };
  const handleItemClick = (item, e) => {
    e.preventDefault();

    // Log de l'action si défini
    if (item.action_log && onActionLog) {
      onActionLog(item.action_log);
    }

    // Callback personnalisé
    if (onItemClick) {
      onItemClick(item, e);
      return;
    }

    // Navigation si link_to est défini
    if (item.link_to) {
      if (item.link_to.startsWith('http')) {
        window.open(item.link_to, '_blank');
      } else if (projectContext?.navigateToPage) {
        projectContext.navigateToPage(item.link_to);
      }
    }
  };
  const handleLogoClick = e => {
    if (onLogoClick) {
      onLogoClick(e);
    }
  };
  const containerClasses = ['header-cell', className].filter(Boolean).join(' ');

  // Générer les styles pour un item
  const getItemStyle = item => {
    const props = item.styles_properties || {};
    return {
      backgroundColor: props.background_color,
      color: props.text_color || styles_properties.text_color,
      fontSize: props.text_size ? `${props.text_size}px` : undefined,
      fontFamily: props.text_font || styles_properties.text_font,
      borderRadius: props.border_radius ? `${props.border_radius}px` : undefined,
      borderColor: props.border_color,
      borderWidth: props.border_width ? `${props.border_width}px` : undefined,
      borderStyle: props.border_style,
      padding: props.padding ? `${props.padding}px` : undefined,
      opacity: props.opacity,
      textAlign: props.text_align,
      cursor: item.link_to ? 'pointer' : 'default',
      textDecoration: 'none'
    };
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
    className: containerClasses,
    style: containerStyle,
    ...rest,
    children: [logoUri && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "header-cell__logo-container",
      onClick: onLogoClick ? handleLogoClick : undefined,
      style: {
        cursor: onLogoClick ? 'pointer' : 'default'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "header-cell__logo",
        src: logoUri,
        alt: logoAlt
      })
    }), items.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
      className: "header-cell__nav",
      children: items.map(item => {
        const itemStyle = getItemStyle(item);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "header-cell__item",
          style: itemStyle,
          onClick: e => handleItemClick(item, e),
          "data-action-log": item.action_log,
          children: item.text
        }, item.id);
      })
    })]
  });
};
var _default = exports.default = HeaderCell;